// extracted by mini-css-extract-plugin
export default {"container":"WFeByPJfWIGc58ShhZiw","wrappedContainer":"CjakShERh9EqRAWelxyQ"};